const imageStyles = { draggable: false, width: '30%', preview: false }

export default imageStyles
